import React, { useState } from "react";
import {
  StyledFilterBlock, StyledFilterBlockTitle,
  StyledFilterCloseBtn, StyledFilterDropdownWrapper,
  StyledFilterGroup,
  StyledFilterWrapper,
  StyledSelectGroup,
  StyledShowFilterBtn
} from "../../../elements/filter/styledFiter";
import Dropdown from "rc-dropdown";
import DefaultButton from "../../../styles/materialButtonStyle";
import { DelayInput } from "react-delay-input/lib/Component";
import { StyledDatepicker } from "../../../styles/styledDatepicker";
import DatePicker from "../../../elements/datePicker/DatePicker";
import { getEndOfDayFromDate, getStartOfDayFromDate, TimestampToDate } from "../../../../utils/timestampToDate";
import TransactionStatusSelect from "../../../elements/transactions/TransactionStatusSelect";
import ReservedBalanceTypeSelect from "../../../elements/transactions/ReservedBalanceTypeSelect";

const ReservedBalanceHistoryFilter = ({ filterData, setFilterData, t }) => {
  const DEFAULT_FILTER_DATA = {
    "page": 1,
    "itemsPerPage": filterData["itemsPerPage"] ?? null,
    "currentTab": filterData["currentTab"] ?? null,
    "id": "",
    "status": null,
    "transactionType": null,
    "dateFrom": null,
    "dateTo": null,
  };

  const [visible, setVisible] = useState(false);

  const onVisibleChange = (visible) => {
    setVisible(visible);
  };

  const handleClearFilter = () => {
    if (filterData["currentTab"]) {
      DEFAULT_FILTER_DATA.currentTab = filterData["currentTab"];
    }

    setFilterData(DEFAULT_FILTER_DATA);
  };

  const FilterList = () => {
    return (
      <>
        {visible && (
          <StyledFilterDropdownWrapper>
            <StyledFilterBlock actions>
              <StyledFilterGroup className="clear-btn">
                <DefaultButton
                  color="transparent"
                  onClick={handleClearFilter}
                >
                  {t("reservedBalance.filter.clearBtn")}
                </DefaultButton>
              </StyledFilterGroup>
              <StyledFilterGroup className="close-btn">
                <StyledFilterCloseBtn onClick={() => setVisible(false)} />
              </StyledFilterGroup>
            </StyledFilterBlock>
            <StyledFilterBlockTitle>
              {t("reservedBalance.filter.filterBy")}:
            </StyledFilterBlockTitle>
            <StyledFilterBlock col="3">
              <StyledFilterGroup>
                <label htmlFor="id">
                  Id
                </label>
                <DelayInput
                  id="id"
                  delayTimeout={2000}
                  onChange={event => setFilterData({ ...filterData, "id": event.target.value, page: 1 })}
                  name="id"
                  value={filterData["id"]}
                  type="text"
                />
              </StyledFilterGroup>
              <StyledSelectGroup>
                <TransactionStatusSelect
                  checkedStatus={filterData["status"]}
                  setCheckedStatus={(data) => setFilterData({ ...filterData, "status": data, page: 1 })}
                  defaultOption={true}
                />
              </StyledSelectGroup>
              <StyledSelectGroup>
                <ReservedBalanceTypeSelect
                  checkedType={filterData["transactionType"]}
                  setCheckedType={(data) => setFilterData({ ...filterData, "transactionType": data, page: 1 })}
                  defaultOption={true}
                />
              </StyledSelectGroup>
            </StyledFilterBlock>
            <StyledFilterBlockTitle>
              {t("reservedBalance.filter.date")}:
            </StyledFilterBlockTitle>
            <StyledFilterBlock col="2">
              <StyledDatepicker>
                <label htmlFor="dateFrom">
                  {t("reservedBalance.filter.dateFrom")}
                </label>
                <DatePicker
                  format="dd-MM-y"
                  id="dateFrom"
                  name="dateFrom"
                  className="date-input"
                  onChange={dateFrom => setFilterData({
                    ...filterData,
                    "dateFrom": getStartOfDayFromDate(dateFrom),
                    page: 1
                  })}
                  value={TimestampToDate(filterData["dateFrom"])}
                />
              </StyledDatepicker>
              <StyledDatepicker>
                <label htmlFor="dateTo">
                  {t("reservedBalance.filter.dateTo")}
                </label>
                <DatePicker
                  format="dd-MM-y"
                  id="dateTo"
                  name="dateTo"
                  className="date-input"
                  onChange={dateTo => setFilterData({
                    ...filterData,
                    "dateTo": getEndOfDayFromDate(dateTo),
                    page: 1
                  })}
                  value={TimestampToDate(filterData["dateTo"])}
                />
              </StyledDatepicker>
            </StyledFilterBlock>
          </StyledFilterDropdownWrapper>
        )}
      </>
    );
  };

  return (
    <StyledFilterWrapper id="filter">
      <Dropdown
        getPopupContainer={() => document.getElementById("filter")}
        overlay={FilterList}
        trigger={["click"]}
        placement="bottomLeft"
        onVisibleChange={onVisibleChange}
        visible={visible}
        closeOnSelect={false}
      >
        <StyledShowFilterBtn>
          <DefaultButton
            color="success"
          >
            {t("wallets.filter.filterBtn")}
          </DefaultButton>
        </StyledShowFilterBtn>
      </Dropdown>
    </StyledFilterWrapper>
  );
};

export default ReservedBalanceHistoryFilter;